import { z } from 'zod'
import { oc } from '@orpc/contract'

/** Generous bound for a scanned EOB/remittance PDF; the wire limit, not a business rule. */
export const EOB_MAX_FILE_BYTES = 25 * 1024 * 1024

// EOB/remittance attachment upload (accounting-plan Task 14): reference-only evidence —
// no OCR, no auto-population. The file travels as a real multipart file part (oRPC
// handles multipart natively for z.file() inputs; the typed client just passes a File),
// and the mime rule admits PDFs only. Deliberately stateless: the returned
// DocumentReference id is journaled by the calls the frontend passes it into
// (saveEob / record-payment).
export const billingV2UploadEob = oc
  .route({ method: 'POST', path: '/v2/billing/eob/upload' })
  .input(
    z.object({
      encounterId: z.string().min(1),
      file: z.file().max(EOB_MAX_FILE_BYTES).mime(['application/pdf']),
    }),
  )
  .output(z.object({ documentId: z.string() }))
